/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Trial_PrInputs */

const en_fc_cmp_trial_pr = /** @type {(inputs: Fc_Cmp_Trial_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7-day free trial`)
};

/**
* | output |
* | --- |
* | "7-day free trial" |
*
* @param {Fc_Cmp_Trial_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_trial_pr = /** @type {((inputs?: Fc_Cmp_Trial_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Trial_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_trial_pr(inputs)
});
export { fc_cmp_trial_pr as "fc.cmp.trial.pr" }